(function ($, Drupal) {

  "use strict";

  // Accordions at small browser size; tabs at larger sizes.
  Drupal.behaviors.accordionsToTabs = {
    attach: function (context, settings) {
      const tabs = $('.tabs', context);

      tabs.each(function () {
        const tabLinks = $(this).find('.tabs__link');
        const accordionLinks = $(this).find('.tabs__heading');
        const tabContents = $(this).find('.tabs__tab');
        let activeIndex = 0;

        var goToTab = function (index, kind) {
          if (index >= 0 && index <= tabLinks.length) {
            $(tabLinks.get(activeIndex)).removeClass('is-active');
            $(tabLinks.get(index)).addClass('is-active');
            if (kind === 'accordion') {
              $(accordionLinks.get(index)).toggleClass('is-active');
              $(tabContents.get(index)).slideToggle(function() {
                $(tabContents.get(index)).addClass('is-active');
              });
            }
            else if (index !== activeIndex) {
              $(tabContents.get(activeIndex)).removeClass('is-active');
              $(tabContents.get(index)).addClass('is-active');
            }
            activeIndex = index;
          }
        };

        tabLinks.each(function () {
          $(this).click(function () {
            goToTab(tabLinks.index(this), 'tab');
          });
        });

        accordionLinks.each(function () {
          $(this).click(function () {
            goToTab(accordionLinks.index(this), 'accordion');
          });
        });
      });

      // No active tab on load for fund pages.
      function removeFundsActiveTab() {
        $('.fund .tabs__heading').first().addClass('is-active');
        $('.fund .tabs__tab').first().addClass('is-active');
        $('.fund .tabs__link').first().addClass('is-active');
        if (window.outerWidth < 992) {
          $('.fund .tabs .is-active').removeClass('is-active');
        }
      }
      removeFundsActiveTab();
      $(window).on('resize', function () {
        removeFundsActiveTab();
      });

      // Go to tab from window.location.
      const hash = window.location.hash;
      const $anchor = $('a[href="' + hash + '"]');
      if (hash && $anchor.length) {
        $anchor.click();

        // Scroll to the tab wrapper.
        $('html,body').animate({
          scrollTop: $anchor.parents('.tabs__wrapper').offset().top
        }, 100);
      }
    }
  };

})(jQuery, Drupal);
